import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const ROLE_LABELS = {
  founder: "Kurucu",
  admin: "Yönetici",
  officer: "Yetkili",
  member: "Ekip Üyesi",
  candidate: "Aday / Dost",
};

export const ROLE_COLORS = {
  founder: "bg-rose-600/20 text-rose-400 border-rose-600/40",
  admin: "bg-amber-600/20 text-amber-400 border-amber-600/40",
  officer: "bg-sky-600/20 text-sky-400 border-sky-600/40",
  member: "bg-emerald-600/20 text-emerald-400 border-emerald-600/40",
  candidate: "bg-zinc-600/20 text-zinc-400 border-zinc-600/40",
};

export const can = (role, ...allowed) => allowed.includes(role);
